import './LoadingT4Carrier.css';

const LoadingT4Carrier = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default LoadingT4Carrier;
